import {all} from 'redux-saga/effects';

import {
  createFetchSagaLatest,
  createFetchSagaEvery,
  createPostSagaLatest
} from 'utils/sagas';

import {
  fetchBooking as fetchBookingAction,
  fetchAgreements as fetchAgreementsAction,
  fetchAgreement as fetchAgreementAction,
  fetchSendAgreementReminderDetails as fetchSendAgreementReminderDetailsAction,
  fetchSendAgreementDetails as fetchSendAgreementDetailsAction,
  fetchAgreementTemplates as fetchAgreementTemplatesAction,
  fetchRentSchedule as fetchRentScheduleAction,
  fetchKycs as fetchKycsAction,
  fetchAffordabilities as fetchAffordabilitiesAction,
  fetchLegacyDocuments as fetchLegacyDocumentsAction,
  fetchRentScheduleSummary as fetchRentScheduleSummaryAction,
  fetchLegacyTypes as fetchLegacyTypesAction,
  fetchAffordability as fetchAffordabilityAction,
  createOffer as createOfferAction,
  addAgreement as addAgreementAction,
  sendAgreementReminder as sendAgreementReminderAction,
  createLegacyDocument as createLegacyDocumentAction,
  verifyKycDocumentsUpload as verifyKycDocumentsUploadAction,
  deleteKycDocument as deleteKycDocumentAction,
  verifyKyc as verifyKycAction,
  verifyAddress as verifyAddressAction,
  verifyPOID as verifyPOIDAction,
  verifyVisa as verifyVisaAction,
  confirmCurrentAddress as confirmCurrentAddressAction,
  requestKycDocument as requestKycDocumentAction,
  addGuarantor as addGuarantorAction,
  addSecondaryTenant as addSecondaryTenantAction,
  removeSecondaryTenant as removeSecondaryTenantAction,
  removeGuarantor as removeGuarantorAction,
  searchTenants as searchTenantsAction,
  applyRentSchedule as applyRentScheduleAction,
  passAffordability as passAffordabilityAction,
  deleteAffordabilityDocument as deleteAffordabilityDocumentAction,
  cancelBooking as cancelBookingAction,
  verifyAffordabilityDocumentUpload as verifyAffordabilityDocumentUploadAction,
  fetchKycDetails as fetchKycDetailsAction,
  fetchKycSectionDetails as fetchKycSectionDetailsAction,
  addEmployment as addEmploymentAction,
  generateRentSchedule as generateRentScheduleAction,
  cancelAgreement as cancelAgreementAction,
  signAgreementManually as signAgreementManuallyAction,
  sendAgreement as sendAgreementAction,
  deleteLegacyDocument as deleteLegacyDocumentAction,
  editLegacyDocument as editLegacyDocumentAction,
  fetchCreateOfferWarnings as fetchCreateOfferWarningsAction,
  createAddressHistory as createAddressHistoryAction,
  fetchBookingActivityLog as fetchBookingActivityLogAction,
  createOneOffChargeInvoiceAndPayment as createOneOffChargeInvoiceAndPaymentAction,
  checkOutTenantsEarly as checkOutTenantsEarlyAction,
  undoCheckOutTenantsEarly as undoCheckOutTenantsEarlyAction
} from './';

import {
  fetchKycs,
  createOffer,
  addAgreement,
  sendAgreement,
  cancelAgreement,
  signAgreementManually,
  sendAgreementReminder,
  fetchBooking,
  fetchAgreement,
  fetchSendAgreementReminderDetails,
  fetchSendAgreementDetails,
  fetchAgreements,
  fetchLegacyDocuments,
  fetchAffordabilities,
  fetchAgreementTemplates,
  fetchRentSchedule,
  fetchLegacyTypes,
  createLegacyDocument,
  searchTenants,
  fetchAffordability,
  verifyAffordabilityDocumentUpload,
  verifyKycDocumentsUpload,
  verifyKyc,
  verifyIdentity,
  verifyVisa,
  verifyAddress,
  fetchKycDetails,
  fetchKycSectionDetails,
  deleteKycDocument,
  generateRentSchedule,
  applyRentSchedule,
  requestKycDocument,
  fetchRentScheduleSummary,
  addGuarantor,
  passAffordability,
  confirmCurrentAddress,
  addEmployment,
  cancelBooking,
  deleteAffordabilityDocument,
  addSecondaryTenant,
  removeSecondaryTenant,
  removeGuarantor,
  deleteLegacyDocument,
  editLegacyDocument,
  fetchCreateOfferWarnings,
  createAddressHistory,
  fetchActivityLog,
  createOneOffChargeInvoiceAndPayment,
  checkOutTenantsEarly,
  undoCheckOutTenantsEarly
} from 'sdk/bookings';

function* bookingDetailSaga() {
  yield all([
    createFetchSagaLatest(fetchBookingAction, fetchBooking),
    createFetchSagaLatest(fetchAgreementsAction, fetchAgreements),
    createFetchSagaLatest(fetchAgreementAction, fetchAgreement),
    createFetchSagaLatest(
      fetchSendAgreementReminderDetailsAction,
      fetchSendAgreementReminderDetails
    ),
    createFetchSagaLatest(
      fetchSendAgreementDetailsAction,
      fetchSendAgreementDetails
    ),
    createFetchSagaLatest(
      fetchAgreementTemplatesAction,
      fetchAgreementTemplates
    ),
    createFetchSagaLatest(fetchRentScheduleAction, fetchRentSchedule),
    createFetchSagaLatest(fetchKycsAction, fetchKycs),
    createFetchSagaLatest(fetchAffordabilitiesAction, fetchAffordabilities),
    createFetchSagaLatest(fetchLegacyDocumentsAction, fetchLegacyDocuments),
    createFetchSagaLatest(
      fetchRentScheduleSummaryAction,
      fetchRentScheduleSummary
    ),
    createFetchSagaLatest(fetchLegacyTypesAction, fetchLegacyTypes),
    createFetchSagaLatest(fetchAffordabilityAction, fetchAffordability),
    createFetchSagaLatest(fetchBookingActivityLogAction, fetchActivityLog),
    createPostSagaLatest(createOfferAction, createOffer),
    createPostSagaLatest(addAgreementAction, addAgreement),
    createPostSagaLatest(sendAgreementReminderAction, sendAgreementReminder),
    createPostSagaLatest(createLegacyDocumentAction, createLegacyDocument),
    createPostSagaLatest(
      verifyKycDocumentsUploadAction,
      verifyKycDocumentsUpload
    ),
    createPostSagaLatest(deleteKycDocumentAction, deleteKycDocument),
    createPostSagaLatest(verifyKycAction, verifyKyc),
    createPostSagaLatest(verifyPOIDAction, verifyIdentity),
    createPostSagaLatest(verifyVisaAction, verifyVisa),
    createPostSagaLatest(verifyAddressAction, verifyAddress),
    createPostSagaLatest(confirmCurrentAddressAction, confirmCurrentAddress),
    createPostSagaLatest(requestKycDocumentAction, requestKycDocument),
    createPostSagaLatest(addGuarantorAction, addGuarantor),
    createPostSagaLatest(addSecondaryTenantAction, addSecondaryTenant),
    createPostSagaLatest(removeSecondaryTenantAction, removeSecondaryTenant),
    createPostSagaLatest(removeGuarantorAction, removeGuarantor),
    createPostSagaLatest(searchTenantsAction, searchTenants),
    createPostSagaLatest(applyRentScheduleAction, applyRentSchedule),
    createPostSagaLatest(passAffordabilityAction, passAffordability),
    createPostSagaLatest(
      deleteAffordabilityDocumentAction,
      deleteAffordabilityDocument
    ),
    createPostSagaLatest(cancelBookingAction, cancelBooking),
    createPostSagaLatest(
      verifyAffordabilityDocumentUploadAction,
      verifyAffordabilityDocumentUpload
    ),
    createFetchSagaLatest(fetchKycDetailsAction, fetchKycDetails),
    createFetchSagaEvery(fetchKycSectionDetailsAction, fetchKycSectionDetails),
    createPostSagaLatest(addEmploymentAction, addEmployment),
    createPostSagaLatest(generateRentScheduleAction, generateRentSchedule),
    createPostSagaLatest(cancelAgreementAction, cancelAgreement),
    createPostSagaLatest(signAgreementManuallyAction, signAgreementManually),
    createPostSagaLatest(sendAgreementAction, sendAgreement),
    createPostSagaLatest(deleteLegacyDocumentAction, deleteLegacyDocument),
    createPostSagaLatest(editLegacyDocumentAction, editLegacyDocument),
    createFetchSagaLatest(
      fetchCreateOfferWarningsAction,
      fetchCreateOfferWarnings
    ),
    createPostSagaLatest(createAddressHistoryAction, createAddressHistory),
    createPostSagaLatest(
      createOneOffChargeInvoiceAndPaymentAction,
      createOneOffChargeInvoiceAndPayment
    ),
    createPostSagaLatest(checkOutTenantsEarlyAction, checkOutTenantsEarly),

    createPostSagaLatest(
      undoCheckOutTenantsEarlyAction,
      undoCheckOutTenantsEarly
    )
  ]);
}

export default bookingDetailSaga;
